import type { SyntheticEvent } from 'react';

/** パウチ・グループ削除ボタン（二段階タップ。シート削除の confirming と同様） */

export const CONFIRMING_DELETE_MS = 2000;

export const POUCH_DELETE_BTN_CLASS = 'pouch-delete-button';
export const GROUP_DELETE_BTN_CLASS = 'group-delete-button';

const CONFIRMING_SELECTOR = `.${POUCH_DELETE_BTN_CLASS}.confirming, .${GROUP_DELETE_BTN_CLASS}.confirming`;

export function clearConfirmingDeleteButtons(): void {
  document.querySelectorAll(CONFIRMING_SELECTOR).forEach(el => {
    el.classList.remove('confirming');
  });
}

function armConfirmingDeleteButton(button: HTMLElement): void {
  clearConfirmingDeleteButtons();
  button.classList.add('confirming');
  window.setTimeout(() => {
    button.classList.remove('confirming');
  }, CONFIRMING_DELETE_MS);
}

/** click / touchend 用（パウチ削除ボタン） */
export function handleConfirmingDeleteButtonClick(
  e: SyntheticEvent,
  onConfirm: () => void
): void {
  e.stopPropagation();
  if ('touches' in e) {
    e.preventDefault();
  }

  const btn = e.currentTarget as HTMLElement;

  if (btn.classList.contains('confirming')) {
    btn.classList.remove('confirming');
    onConfirm();
    return;
  }

  armConfirmingDeleteButton(btn);
}

/** mouseup / touchend 用（グループ削除ボタン・短押し） */
export function handleConfirmingDeleteButtonRelease(
  button: HTMLElement | null,
  onConfirm: () => void
): void {
  if (!button) {
    return;
  }

  if (button.classList.contains('confirming')) {
    button.classList.remove('confirming');
    onConfirm();
    return;
  }

  armConfirmingDeleteButton(button);
}
